const AutoLogin = () => null;

export default AutoLogin;
